/**
 * 全站路由配置
 *
 * 建议:
 * 1. 代码中路由统一使用name属性跳转(不使用path属性)
 */
import Vue from 'vue'
import Router from 'vue-router'
import accountApi from '../service/account_api'
import login from '../views/login.vue'
import master from '../views/master.vue'
import home from '../views/home.vue'
import Utils from '../lib/utils'

Vue.use(Router)

// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
    { path: '/login', component: login, name: 'login', meta: { title: '登录' } }
]

// 主入口路由(需嵌套上左右整体布局)
const mainRoutes = {
    path: '/',
    component: master,
    name: 'master',
    redirect: { name: 'home' },
    meta: '',
    children: [
        // 通过meta对象设置路由展示方式
        // 1. isTab: 是否通过tab展示内容, true: 是, false: 否
        // 2. iframeUrl: 是否通过iframe嵌套展示内容, '以http[s]://开头': 是, '': 否
        // 提示: 如需要通过iframe嵌套展示内容, 但不通过tab打开, 请自行创建组件使用iframe处理!
        { path: '/home', component: home, name: 'home', meta: { title: '超2后台|首页' } },
    ],
    beforeEnter (to, from, next) {
        let token = Utils.getCookie('user')
        if (!token || !/\S/.test(token)) {
            next({ name: 'login' })
        }
        next()
    }
}

const router = new Router({
    mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
    routes: globalRoutes.concat(mainRoutes)
})

router.beforeEach((to, from, next) => {
    // 添加动态(菜单)路由
    // 1. 已经添加 or 全局路由, 直接访问
    // 2. 获取菜单列表, 添加并保存本地存储
    if (router.options.isAddDynamicMenuRoutes || fnCurrentRouteType(to, globalRoutes) === 'global') {
        next()
    } else {
        accountApi.allMenu().then(data => {
            if (data) {
                var permissions = JSON.parse(Utils.getCookie('permissions'));
                console.log("permissions",...permissions)

                var _data = [];
                data.forEach((item,index) => {
                    for (var i in permissions) {
                        if (item.id == i) {
                            _data.push(item)
                        }
                    }
                })
                _data.forEach((item,index) => {
                    var subMenus = [];
                    for (var i in permissions) {
                        if (item.id == i) {
                            item.subMenus.forEach((item2,index2) => {
                                // if (permissions[i].indexOf(item2.id)===-1) {
                                //     item.subMenus.splice(index2,1)
                                // }
                                if (permissions[i].indexOf(item2.id)!==-1) {
                                    subMenus.push(item2)
                                }
                            })
                        }
                    }
                    item.subMenus = subMenus;
                })

                fnAddDynamicMenuRoutes(_data)
                if (_data) {
                    router.options.isAddDynamicMenuRoutes = true
                }

                sessionStorage.setItem('menuList', JSON.stringify(_data || '[]'))
                next({ ...to, replace: true })
            } else {
                sessionStorage.setItem('menuList', '[]')
                next()
            }
        }).catch((e) => {
            console.log(`%c${e} 请求菜单列表和权限失败，跳转至登录页！！`, 'color:blue')
            router.push({ name: 'login' })
        })
    }
})

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType (route, globalRoutes = []) {
    var temp = []
    for (var i = 0; i < globalRoutes.length; i++) {
        if (route.path === globalRoutes[i].path) {
            return 'global'
        } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
            temp = temp.concat(globalRoutes[i].children)
        }
    }
    return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main'
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes (menuList = [], routes = []) {
    var temp = []
    for (var i = 0; i < menuList.length; i++) {
        if (menuList[i].subMenus && menuList[i].subMenus.length >= 1) {
            temp = temp.concat(menuList[i].subMenus)
        } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
            menuList[i].url = menuList[i].url.replace(/^\//, '')
            var route = {
                path: menuList[i].url,
                component: null,
                name: menuList[i].url,
                meta: {
                    id: menuList[i].id,
                    title: menuList[i].name,
                    isDynamic: true,
                    isTab: true,
                    iframeUrl: ''
                }
            }
            if (isURL(menuList[i].url)) {
                route['path'] = `i-${menuList[i].id}`
                route['name'] = `i-${menuList[i].id}`
                route['meta']['iframeUrl'] = menuList[i].url
            } else {
                try {
                    route['component'] = require(`../views/${menuList[i].url}`) || null
                    route['component'] = route['component']['default']
                } catch (e) {}
            }
            routes.push(route)
        }
    }
    if (temp.length >= 1) {
        fnAddDynamicMenuRoutes(temp, routes)
    } else {
        mainRoutes.name = 'main-dynamic'
        mainRoutes.children = routes
        router.addRoutes([
            mainRoutes,
            { path: '*', redirect: { name: '404' } }
        ])
        sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'))
        console.log('\n')
        console.log('%c!<-------------------- 动态(菜单)路由 s -------------------->', 'color:blue')
        console.log('%c!<-------------------- 动态(菜单)路由 e -------------------->', 'color:blue')
    }
}

function isURL (s) {
    return /^http[s]?:\/\/.*/.test(s)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js